module.exports = __webpack_public_path__ + "9011c6554806b44119f0bbb868c16c6b.png";